module.exports = __webpack_public_path__ + "assets/checkered_finish_flag.fbd9944b.svg";